import { render, staticRenderFns } from "./TextAnswerWysiwyg.vue?vue&type=template&id=922ecce0&scoped=true&"
import script from "./TextAnswerWysiwyg.vue?vue&type=script&lang=ts&"
export * from "./TextAnswerWysiwyg.vue?vue&type=script&lang=ts&"
import style0 from "./TextAnswerWysiwyg.vue?vue&type=style&index=0&id=922ecce0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "922ecce0",
  null
  
)

export default component.exports